import { FunctionComponent } from 'react';

interface PageTitleProps
{
    title: string;
}

const PageTitle: FunctionComponent<PageTitleProps> = (props) =>
{
    /** Render */
    return (
        <div className="page-title">
            <div className="font-size-3 mb-3 fw-bold">{props.title}</div>
        </div>
    );
}

export default PageTitle;